import { Injectable } from '@angular/core';
import { AuthService } from '../../services/auth.service';
import { Actions, ofType, createEffect } from '@ngrx/effects';
import {
  loadServices,
  loadServicesFailure,
  loadServicesSuccess, loadSubpages, loadSubpagesFailure, loadSubpagesSuccess,
  login,
  loginFailure, loginGovPl, loginGovPlFailure, loginGovPlSuccess,
  loginSuccess, logout
} from '../actions/app.actions';
import { catchError, map, of, switchMap, tap } from 'rxjs';
import { SessionService } from '../../services/ssession.service';
import { SubpageService } from '../../openapi';
import { HttpErrorResponse } from '@angular/common/http';
import { ServiceCommonService } from '../../services/service.common.service';

@Injectable()
export class AppEffects {
  constructor(
    private authService: AuthService,
    private serviceCommonService: ServiceCommonService,
    private subpageService: SubpageService,
    private actions$: Actions
  ) {
  }

  login$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(login),
      switchMap(action =>
        this.authService.getToken(action.payload)
          .pipe(
            map(data => {
              SessionService.SetAccessToken(data.token);
              action.successFnc();
              return loginSuccess({ data });
            }),
            catchError(() => {
              action.failureFnc();
              return of(loginFailure());
            })
          )
      )
    );
  });

  loginGovPl$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(loginGovPl),
      switchMap(payload =>
        this.authService.authLoginGovPl({
          samlart: payload.samlart
        }).pipe(
          map(v => {
            if (v?.token) {
              SessionService.SetAccessToken(v.token);
            }
            payload.successFnc(SessionService.GetTokenData());
            return loginGovPlSuccess();
          }),
          tap({
            next: v => v,
            error: (v: HttpErrorResponse) => {
              payload.failureFnc(v);
              return of(loginGovPlFailure());
            }
          })
        )
      )
    );
  });

  logout$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(logout),
      tap(action => {
        SessionService.Logout();
        action.successFnc();
      })
    );
  }, { dispatch: false });

  loadServices$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(loadServices),
      switchMap(() => {
        return this.serviceCommonService.loadServices({ pagination: false })
          .pipe(
            map(services => loadServicesSuccess({ services })),
            catchError(() => of(loadServicesFailure()))
          );
      })
    );
  });

  loadSubpages$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadSubpages),
      switchMap(() =>
        this.subpageService.getSubpagesCollectionSubpageCollection({
          pagination: false
        }).pipe(
          map(subpages => loadSubpagesSuccess({ subpages })),
          catchError(() => of(loadSubpagesFailure()))
        )
      )
    )
  );
}
